import React from "react";
import {
  GKIconName,
  GKIcon,
  GKPosition,
  Position,
} from "@granular/gds-ux-components";

export const Failed: React.FC = () => {
  return (
    <div className="w-100 h-100 position-relative">
      <GKPosition position={Position.CC}>
        <div>
          <h1 className="text-center text-warning">
            <GKIcon name={GKIconName.Warning} />
          </h1>
          <h3 className="text-center text-warning">
            {/* This require translations? */}
            Component has failed to load
          </h3>
        </div>
      </GKPosition>
    </div>
  );
};
